import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { LoaderCircle } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Label } from '@/components/ui/label'
import { Textarea } from '@/components/ui/textarea'

interface Props { open: boolean; onOpenChange: (open: boolean) => void; onReject: (note: string) => Promise<boolean>
  titleKey?: string; hintKey?: string; noteKey?: string; actionKey?: string }

/** Rejection needs a note (ruling Q6); the submitter gets it by e-mail. */
const RejectDialog: React.FC<Props> = ({ open, onOpenChange, onReject, titleKey = 'CostControl_change_reject_title', hintKey = 'CostControl_change_reject_hint', noteKey = 'CostControl_change_reject_note', actionKey = 'CostControl_change_reject' }) => {
  const { t } = useTranslation()
  const [note, setNote] = useState('')
  const [submitting, setSubmitting] = useState(false)
  useEffect(() => { if (open) { setNote(''); setSubmitting(false) } }, [open])
  const submit = async () => {
    if (!note.trim() || submitting) return
    setSubmitting(true)
    const ok = await onReject(note.trim())
    setSubmitting(false)
    if (ok) onOpenChange(false)
  }
  return (
    <Dialog open={open} onOpenChange={(next) => { if (!submitting) onOpenChange(next) }}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{t(titleKey)}</DialogTitle>
          <DialogDescription>{t(hintKey)}</DialogDescription>
        </DialogHeader>
        <div className="space-y-1.5">
          <Label htmlFor="cc-reject-note">{t(noteKey)} *</Label>
          <Textarea id="cc-reject-note" rows={4} value={note} onChange={(e) => setNote(e.target.value)} autoFocus />
        </div>
        <div className="flex items-center justify-end gap-2 border-t pt-4">
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={submitting}>{t('Common_cancel')}</Button>
          <Button variant="destructive" onClick={submit} disabled={submitting || !note.trim()}>
            {submitting && <LoaderCircle className="h-4 w-4 animate-spin" />}
            {t(actionKey)}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
export default RejectDialog
